import shareUrl from "@/utils/shareUrl.js";

export default function (element, data) {
  element.addEventListener("click", function () {
    shareUrl(window.location);
  });
}
